import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const ErrorModal = ({ open, message, onClose }) => {
    const overlayRef = useRef(null);

    // Close on ESC
    useEffect(() => {
        if (!open) return;
        const handleKeyDown = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [open, onClose]);

    // Click outside (backdrop)
    const handleBackdropClick = (e) => {
        if (e.target === overlayRef.current) onClose();
    };

    const handleTextUs = () => {
        window.location.href = "sms:+17816504492";
    };

    if (!open) return null;

    return createPortal(
        <div
            ref={overlayRef}
            className="modal-overlay"
            onMouseDown={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="error-modal-title"
        >
            <div className="modal-content">
                <div className="modal-header modal-header--error">
                    <h3 id="error-modal-title">Something went wrong</h3>
                </div>

                <div className="modal-body">
                    <p className="modal-error-text">{message}</p>
                </div>

                <div className="modal-actions">
                    <button
                        type="button"
                        onClick={onClose}
                        className="modal-button modal-button-secondary"
                    >
                        Try Again
                    </button>
                    <button
                        type="button"
                        onClick={handleTextUs}
                        className="modal-button modal-button-primary"
                    >
                        Text Us
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ErrorModal;
